<script lang="ts" setup>
// import { useIntersectionObserver } from "@vueuse/core";
// import { ref } from "vue";
import Badge from "@/components/ui/badge/Badge.vue";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Globe } from "lucide-vue-next";
import { onMounted } from "vue";
import { loadIsPartnerInfo, type websiteListType } from "@partner-spa-vue/stores/MyWebsitesStore";

const props = defineProps<{
    website: websiteListType[number] & {
        isSupportTeamPartner: boolean;
        isMarketingTeamPartner: boolean;
    };
}>();

// const cardRef = ref<HTMLElement | null>(null);

onMounted(() => {
    loadIsPartnerInfo(props.website.id);
});

// const { stop } = useIntersectionObserver(
//     cardRef,
//     ([entry]) => {
//         if (entry?.isIntersecting) {
//             stop();
//             loadIsPartnerInfo(props.website.id);
//         }
//     },
//     { rootMargin: "1px" },
// );
</script>

<template>
    <RouterLink :to="`/website/${website.id}`"
                class="block">
        <div ref="cardRef">
            <Card class="bg-muted hover:bg-muted/20 transition-colors">
                <CardHeader>
                    <CardTitle class="text-lg">
                        <Globe class="inline-block mr-1" />
                        {{ website.name }}
                    </CardTitle>
                    <CardDescription>{{ website.defaultHostname }}</CardDescription>
                </CardHeader>
                <CardContent>
                    <Badge v-if="website.isSupportTeamPartner">
                        Support Partner
                    </Badge>
                    <br>
                    <Badge v-if="website.isMarketingTeamPartner">
                        Affiliate Partner
                    </Badge>
                </CardContent>
            </Card>
        </div>
    </RouterLink>
</template>
